<h2>main</h2>
<p>{{main.ctrlName}}</p>